<template>
	<div id="app" :class="vueAppClasses" class="vs-con-loading__container">
		<router-view @setAppClasses="setAppClasses" />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import update from './mixins/update'
import { initJsStore } from "@/db/idb_service";

export default {
  data() {
    return {
      vueAppClasses: [],
    }
  },
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    },
    '$store.state.whatsappStatus'(){
      this.setOfflinePlatform()
    },
    '$store.state.maintenanceStatus'(){
      this.setOfflinePlatform()
    }
  },
  mixins: [update],
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setOfflinePlatform() {
      this.$store.dispatch("updateOfflinePlatform", (
          !this.$store.state.whatsappStatus
          || this.$store.state.maintenanceStatus
      ));
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  mounted() {

    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  async created() {
    try {
      const isDbCreated = await initJsStore();
      if (isDbCreated) {
        console.log("db created", isDbCreated);
      } else {
        console.log("db opened");
      }  
    } catch (e) {
      this.$vs.notify({
        color: "danger",
        title: "Navegador não suportado!",
        text: "Não é possível utilizar o " + process.env.VUE_APP_APP_TITLE + " neste navegador no modo anônimo",
        time: 10000,
      })
      console.log('erro', e)
    }
    
    let dir = this.$vs.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    // Auth0
    try       { await this.$auth.renewTokens() }
    catch (e) { console.error(e) }

  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
}

</script>
<style lang="scss">
  .d-flex {
    display: flex;
  }

  .justify-content-flex-end {
    justify-content: flex-end;
  }
</style>
